export default __webpack_public_path__ + "static/media/icono2gris.bd243e55.svg";